import { inject, injectable } from 'inversify';
import {
  InjectionSymbols as LoggerInjectionSymbols,
  type Logger,
} from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Team, TeamBackend } from './team.interfaces';
import { defaultSelectors, defaultDispatchers } from './teams.slice';
import { ReduxRepository } from '../reduxRepository';
import { TeamTranslator } from './team.translator';
import { createTeamThunk } from './teamCreate.thunk';
import { updateTeamThunk } from './teamUpdate.thunk';
import { deleteTeamThunk } from './teamDelete.thunk';
import { loadTeamsThunk } from './teamLoad.thunk';
import { Player } from '../players/player.interfaces';

@injectable()
export class TeamRepository extends ReduxRepository<Team, TeamBackend> {
  constructor(
    @inject(LoggerInjectionSymbols.LOGGER)
    protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<TeamBackend>,
  ) {
    super(
      ModelTypes.Team,
      new TeamTranslator(),
      datastore,
      loggingService,
      defaultSelectors,
      defaultDispatchers,
      createTeamThunk,
      updateTeamThunk,
      deleteTeamThunk,
      loadTeamsThunk,
    );
  }
}
